// extracted by mini-css-extract-plugin
module.exports = {"dock":"Dock_dock__I2PSe","button":"Dock_button__o6dEr","active":"Dock_active___b98D","red":"Dock_red__xdosv","title":"Dock_title__85sZg"};